module Meevo.Plugins.AppointmentBook.Services {
    export interface IAppointmentBookModalConfig {
        message?: string;
        buttonsType?: Meevo.Model.ButtonTypeEnum;
        callback?: (response: any, callbackParam?: any) => void;
        messageClass?: string;
        customTemplateId?: string;
        callbackParam?: any;
        showAsHtml?: boolean;
    }

    export interface ModalMessage {
        message: string;
    }

    export class AppointmentBookModalService {
        static $inject = [
            '$rootScope',
            'appointmentBookGlobalsService',
            'meevo.components.modal.ModalService',
            '$mdDialog',
            '$translate',
            "meevo.components.busy.BusyService"
        ];

        constructor(
            private $rootScope: ng.IRootScopeService,
            private globals,
            private modalService: Meevo.Components.Modal.ModalService,
            private $mdDialog,
            private $translate: angular.translate.ITranslateService,
            private busyService: Meevo.Components.Busy.IBusyService
        ) {
        }

        private clientFindLocation = "";
        private appointmentEditorLocation = "";
        private blockEditorLocation = "app/plugins/AppointmentBook/views/BlockEditor.html";
        private appointmentBookFiltersLocation = "";
        private standingEditorLocation = "";
        private appointmentBookMenuLocation = "";
        private blockDefinitionEditorLocation = "";
        private clientEditorLocation = "";
        private removeCallback = null;
        private isSharingResourceAssistantOpened = false;

        queuedModalOptions = [];
        outStandingPromise;
        private showModal(templateUrl, controller: any = undefined, onComplete: any = undefined, locals: any = undefined, controllerAs: string = undefined, multiple: boolean = true) {
            let options: Meevo.Components.Modal.IModalOptions = {
                templateUrl: templateUrl,
                controller: controller,
                controllerAs: controllerAs,
                bindToController: true,
                multiple: multiple,
                skipHide: true,
                onComplete: onComplete,
                onRemoving: this.removeCallbackFunc,
                locals: locals
            }
            //if (!this.outStandingPromise || this.outStandingPromise.$$state.status == 1) {
            return this.showModalWithOptions(options);
            //} else {
            //    this.queuedModalOptions.push(options);
            //}
        }

        private showModalWithOptions(options) {

            $("#divAppointmentBookScrollContainer").css("overflow", "hidden");

            this.outStandingPromise = this.modalService.showCustom(options).then((result) => {
                this.busyService.stop();
                $("#divAppointmentBookScrollContainer").css("overflow", "");

                if (result && result.callback) {
                    result.callback(result.result, result.callbackParam);
                }
                if (this.queuedModalOptions.length > 0) {
                    return this.showModalWithOptions(this.queuedModalOptions.shift());
                }

                //$("#divAppointmentBookScrollContainer").css("overflow", "");

                return result;
            });
            return this.outStandingPromise;
        }

        private editStandingComplete;
        private openClientFindComplete() {
            this.$rootScope.$broadcast("openClientFind");
        }

        // Below method is to enable scrolling right after modal close.. BUG #69325
        private removeCallbackFunc() {
            //$(".md-dialog-container").remove();
            $("#divAppointmentBookContainer").focus();
        }

        // Below method is to enable scrolling right after modal close.. BUG #69325
        public setRemoveCallback(removeCallback: any = null) {
            this.removeCallback = removeCallback;
        }

        public showAppointmentBookFilterMenu(opacityFilterSelections) {
            this.showModal("app/plugins/AppointmentBook/views/AppointmentBookMenu.html", "AppointmentBookMenuController", undefined, { opacityFilterSelections: opacityFilterSelections });
        }

        public showTenantLocation() {
            this.showModal("app/plugins/AppointmentBook/views/tenantLocationFind.html");
        }

        public showColumnOrdering() {
            // the constructor is getting called twice, this is a workaround to stop the second call from getting inside
            this.globals.initializingColumnOrderDialog = true;
            this.showModal("app/plugins/AppointmentBook/views/columnOrder.html", "ColumnOrderController", undefined);
            this.hideAppointmentDetails();
        }

        public hideModal(result) {
            return this.$mdDialog.hide(result);
        }

        public showFilters(services, employees, employeeCategories, resources, displayNoShows, gender) {
            this.showModal("app/plugins/AppointmentBook/views/AppointmentBookFilters.html", "AppointmentBookFiltersController", undefined, { services: services, employees: employees, employeeCategories: employeeCategories, resources: resources, displayNoShows: displayNoShows, gender: gender });
            this.hideAppointmentDetails();
        }

        public showResourceCountFilters(resourceCat) {
            this.showModal("app/plugins/AppointmentBook/views/ResourceCountFilters.html", "meevo.plugins.appointmentBook.ResourceCountFiltersController", undefined, { resourceCat: resourceCat },"vm");
            this.hideAppointmentDetails();
        }

        public serviceInformation(serviceId) {
            this.showModal("app/plugins/AppointmentBook/views/serviceInformation.html", "meevo.plugins.appointmentBook.ServiceInformationController", undefined, { serviceId: serviceId }, "vm");
        }

        public showSteps(currentDetail, currentAppointment, isReadOnly) {
            this.hideAppointmentDetails();
            return this.showModal("app/plugins/AppointmentBook/views/AppointmentBookSteps.html", "AppointmentBookStepsController", undefined, {
                currentDetail: currentDetail,
                currentAppointment: currentAppointment,
                isReadOnly: isReadOnly,
                isFromBook: false,
            });
        }

        public showEditCheckedOutService(currentDetail, currentAppointment) {
            this.hideAppointmentDetails();
            return this.showModal("app/plugins/AppointmentBook/views/AppointmentBookSteps.html", "AppointmentBookStepsController", undefined, {
                currentDetail: currentDetail,
                currentAppointment: currentAppointment,
                isReadOnly: false,
                isFromBook: true,
            });
        }

        public serviceAddOns(serviceId, employeeId, editorService) {
            // unused?
            this.showModal("app/plugins/AppointmentBook/views/serviceAddOns.html", "meevo.plugins.appointmentBook.ServiceAddOnsController", undefined, {
                serviceId: serviceId,
                employeeId: employeeId,
                editorService: editorService,
                isFromWalkIn: false
            }, "vm");
        }

        public resourceSharing(appointmentServiceId, editorService,resourceUnits) {
            if (!this.isSharingResourceAssistantOpened) {
                this.isSharingResourceAssistantOpened = true;

                return this.showModal(
                    "app/plugins/AppointmentBook/views/ResourceSharingAssistant.html",
                    "meevo.plugins.appointmentBook.ResourceSharingController",
                    undefined,
                    {
                        appointmentServiceId: appointmentServiceId,
                        editorService: editorService,
                        resourceUnitAppointmentServices: resourceUnits
                    },
                    "vm",
                    false).then(() => this.isSharingResourceAssistantOpened = false);
            }
        }

        public showAppointmentAuditLog(appointmentId) {
            this.busyService.start();
            this.showModal("app/plugins/AppointmentBook/views/AppointmentAuditLog.html", "AppointmentAuditLogController", undefined, { appointmentId: appointmentId, appointmentServiceScheduleId: undefined, appointmentRequestId: undefined });
            this.hideAppointmentDetails();
        }

        public showBlockAuditLog(blockId) {
            this.busyService.start();
            this.showModal("app/plugins/AppointmentBook/views/AppointmentAuditLog.html", "BlockAuditLogController", undefined, { blockId: blockId });
            this.hideBlockDetails();
        }

        public showDocsAndForms(docsAndForms, formCollectionState: Meevo.Plugins.AppointmentBook.FormCollectionStateEnum, request: any, appointmentServices=null, iframeCallback: Function = null) {
            return this.showModal("app/plugins/AppointmentBook/views/DocsAndForms.html", "meevo.plugins.appointmentBook.DocsAndFormsController", undefined, { forms: docsAndForms, formCollectionState: formCollectionState, request: request, appointmentServices: appointmentServices, iframeCallback: iframeCallback}, "vm");
        }

        public showClientHistory(clientId) {
            if (clientId !== undefined) {
                this.showModal("app/plugins/AppointmentBook/views/ClientHistory.html", "ClientHistoryController", undefined, { clientId: clientId });
                this.hideAppointmentDetails();
            }
        }

        public sendToTransactionHistory(client: any, section: string, subSection: string = null) {
            if (!client || !client.id) {
                return;
            }

            this.$rootScope.$broadcast(Meevo.Components.Common.Messages.GOTO_STATE, {
                stateName: "client",
                stateParams: {
                    actionState: Meevo.Model.MaintenanceFormState.Readonly,
                    targetState: Meevo.Model.MaintenanceFormVisualState.Detail,
                    callback: null,
                    callbackState: "appointmentBook",
                    id: client.id,
                    initialEditSection: section,
                    initialEditSubSection: subSection,
                    clientDisplayName: client.displayName
                }
            });
        }

        public showMenu() {
            this.globals.currentPopupId = "divAppointmentBookMenu";
            this.globals.showZoom = false;
            this.globals.showViews = false;
            $("#divAppointmentBookMenu").show();
        }

        public showGoMenu() {
            this.globals.currentPopupId = "appointmentBookGo";
            $("#appointmentBookGo").show();
        }

        public showCutCopyClipboard() {
            $("#divCutCopy").show();
            this.globals.showHideCutCopyContainer();
        }

        public hideClipIfNoVisibleChildren() {
            if (!this.clipboardHasVisibleChildren()) {
                this.hideCutCopyClipboard();
            }
        }

        public clipboardHasVisibleChildren() {
            return $("#divCutCopy").find(".cutcopyWrapper").not(".hideHighlight").length > 0;
        }

        public hideCutCopyClipboard() {
            $("#divCutCopy").hide();
            this.globals.showHideCutCopyContainer();
        }

        public disposeCutCopyClipboardIfEmpty() {
            if (!this.clipboardHasVisibleChildren()) {
                this.disposeCutCopyClipboard();
            }
        }

        public disposeCutCopyClipboard() {
            if ($("#divClipboardRebook").find(".cutcopyWrapper").length > 0) {
                var that = this;
                let rebookElements = $("#divClipboardRebook").find(`[data-clipboard-action='${Meevo.Model.ClipboardActionEnum.Rebook}']`);
                for (let i = 0; i < rebookElements.length; i++) {
                    if (this.globals.rebookCandidates[$(rebookElements[i]).data("clipboardActionId")].fromRegister) {
                        this.$rootScope.$broadcast("gotoState", { stateName: "register" });
                        break;
                    }
                }
            }

            $("#divCutCopy").find(".cutcopyWrapper").remove();
            $(".cutCopyHeader").hide();
            $("#divCutCopy").hide();
            this.globals.cutCopyIds = [];
            this.globals.copyCutAppointmentServiceId = undefined;

            this.globals.showHideCutCopyContainer();
            this.$rootScope.$broadcast("updateAppointmentOverlays",{});
        }

        private cleanupResizable() {
            $('.appt-book-step-resize-helper, .ui-resizable-handle').remove();
        }

        public hideBlockDetails() {
            this.globals.divBlockDetails.hide();
            this.cleanupResizable();
        }

        public hideAppointmentDetails() {
            this.globals.divAppointmentDetails.hide();
            this.cleanupResizable();
        }

        public showProcessingOverlay() {
            $("#divProcessingOverlay").show();
        }

        public hideProcessingOverlay() {
            $("#divProcessingOverlay").hide();
        }

        public showMessages(messages: Array<ModalMessage>, headerTranslateKey: string, config: Meevo.Plugins.AppointmentBook.Services.IAppointmentBookModalConfig = undefined, showContinuePrompt: boolean = true) {
            var msg = "";
            if (messages != null) {
                msg = messages.map(m => m.message).join('</li><li>');
            }

            return this.showMessage(`${this.$translate.instant(headerTranslateKey)}<br><br><ul><li>${msg}</li></ul><br>${showContinuePrompt ? this.$translate.instant("MESSAGE_CONTINUE_PROMPT") : ''}`, config);
        }

        public showMessage(message: string, config: Meevo.Plugins.AppointmentBook.Services.IAppointmentBookModalConfig = undefined, multiple: boolean = true) {
            return this.showModal("app/plugins/AppointmentBook/views/Message.html",
                "meevo.plugins.appointmentBook.MessageController",
                undefined,
                { message: message, config: config },
                "vm",
                multiple
            );
        }

        public showDeleteDialog(appointmentServiceIdsToDelete) {
            return this.showModal(
                "app/plugins/AppointmentBook/views/DeleteReason.html",
                "meevo.plugins.appointmentBook.DeleteController",
                undefined,
                {
                    appointmentServiceIdsToDelete
                },
                "vm"
            );
        }

        public showNotesModal() {
            return this.showModal('app/plugins/AppointmentBook/views/NotesModal.html',
                "meevo.plugins.appointmentBook.NotesController",
                undefined,
                {},
                "vm");
        }
    }

    angular.module('ApptBookApp').service('appointmentBookModalService', AppointmentBookModalService);
    angular.module('ApptBookApp').service('Meevo.Plugins.AppointmentBook.Services.AppointmentBookModalService', AppointmentBookModalService);
}